export default "__VITE_ASSET__o4X3rPRa__"